module.exports = __webpack_public_path__ + "img/marker_one_red2.aea39061.png";